import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Take full control of scroll position. The browser's automatic restoration
// fights with our manual logic (AnalyticsWrapper scroll-to-top + per-page
// restore), producing wrong positions on back navigation. Manual = ours wins.
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
